import React, { useCallback } from 'react';

/**
 * DocumentCardRender - Version harmonisée avec ExplorationNotes.js
 * Utilise les mêmes styles de paragraphes et de texte pour une cohérence visuelle
 */
const DocumentCardRender = ({ 
  content, 
  document, 
  className = '', 
  onPassageClick 
}) => {
  // Fonction pour gérer le clic sur une phrase avec référence de page
  const handleSentenceClick = useCallback((pageNumber, sentenceText) => {
    if (!onPassageClick || !document || !document.id) return;
    
    console.log("DocumentCardRender: Clic sur phrase avec page", pageNumber);
    
    // Créer l'objet passage avec toutes les informations nécessaires
    const passage = {
      id: `passage-${document.id}-page-${pageNumber}-${Date.now()}`,
      pageNumber: pageNumber,
      content: sentenceText,
      documentId: document.id,
      document: document
    };
    
    // Appeler le gestionnaire avec docId et passage
    onPassageClick(document.id, passage);
  }, [document, onPassageClick]);
  
  // Si pas de contenu, afficher un message par défaut
  if (!content) {
    return <p className="text-sm text-gray-600">Pas de résumé disponible</p>;
  }
  
  // Diviser le contenu en paragraphes
  // 1. D'abord vérifier s'il y a des sauts de ligne doubles (paragraphes explicites)
  let paragraphs = content.split(/\n\n+/);
  
  // 2. Si pas de paragraphes explicites et texte long, créer des paragraphes logiques
  if (paragraphs.length === 1 && content.length > 200) {
    // Diviser en phrases
    const sentences = content.split(/\.\s+(?=[A-Z])/);
    paragraphs = [];
    
    // Regrouper les phrases par lots de 3 pour former des paragraphes
    for (let i = 0; i < sentences.length; i += 3) {
      const chunk = sentences.slice(i, i + 3).join('. ');
      if (chunk) {
        paragraphs.push(chunk + (chunk.endsWith('.') ? '' : '.'));
      }
    }
  }
  
  // Fonction pour rendre un paragraphe avec ses phrases cliquables
  const renderParagraph = (paragraphText, paragraphIndex) => {
    // Diviser le paragraphe en phrases
    const sentences = paragraphText.split(/(?<=\.\s)/).filter(Boolean);
    
    return (
      <p key={`paragraph-${paragraphIndex}`} className="mb-5 last:mb-0 text-justify leading-relaxed text-gray-800">
        {sentences.map((sentence, sentenceIndex) => {
          // Chercher une référence de page dans la phrase
          const pageNumberMatch = sentence.match(/\(page\s*(\d+)\)/i);
          
          if (pageNumberMatch && pageNumberMatch[1]) {
            // Si une référence de page est trouvée, rendre une phrase cliquable
            const pageNumber = parseInt(pageNumberMatch[1], 10);
            
            return (
              <span 
                key={`${paragraphIndex}-${sentenceIndex}`}
                className="inline cursor-pointer hover:bg-blue-50 hover:font-semibold px-1 -mx-1 rounded transition-all"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSentenceClick(pageNumber, sentence);
                }}
                title={`Cliquez pour voir la page ${pageNumber} du document`}
              >
                {sentence}
              </span>
            );
          } else {
            // Phrase normale sans référence de page
            return (
              <span key={`${paragraphIndex}-${sentenceIndex}`} className="inline">
                {sentence}
              </span>
            );
          }
        })}
      </p>
    );
  };
  
  return (
    <div className={className}>
      {paragraphs.map((paragraph, index) => renderParagraph(paragraph, index))}
    </div>
  );
};

export default DocumentCardRender;